import styled from 'styled-components';

export const AboutKyuOsKeepScrollingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const AboutKyuOsKeepScrollingText = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;
